import React from 'react';

export default function SafetySummary() {
  // Define the list items outside of the JSX to keep the render block clean
  const safetyPoints = [
    '金融庁に正式登録された国内正規業者（関東財務局長（金商）第1629号）',
    '全額信託保全で万が一の場合もお客様の資産は全額保護',
    'SSL暗号化・二段階認証など最新のセキュリティ対策を実施',
    '24時間電話・LINEサポートで初心者も安心',
    'FX口座数90万口座突破の圧倒的な実績と信頼',
    'デモ取引で無料練習してから本番に臨める',
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-teal-50 to-emerald-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-emerald-100 rounded-lg mb-4">
            <i className="ri-check-double-line text-2xl text-emerald-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            まとめ：安心して始められる理由
          </h2>
        </div>

        <div className="bg-gradient-to-br from-teal-50 via-emerald-50 to-white rounded-2xl p-8 border border-teal-100 mb-8">
          <p className="text-gray-700 leading-relaxed mb-6">
            「DMM FXは危険？」という疑問に対する答えは、<strong>「DMM FX自体は安全な業者」</strong>です。危険と言われる理由の多くはFXという投資商品そのもののリスクであり、DMM FXという会社の問題ではありません。
          </p>

          <div className="space-y-3 mb-6">
            {safetyPoints.map((text, index) => (
              <div key={index} className="flex items-start">
                <div className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
                <p className="text-sm text-gray-700">{text}</p>
              </div>
            ))}
          </div>

          <p className="text-gray-700 leading-relaxed">
            大切なのは、<strong>余裕資金で始めること、レバレッジを低く抑えること、損切りルールを決めること</strong>。この3つを守れば、FXのリスクを大幅に軽減できます。DMM FXは初心者が安全にFXを始めるための環境が十分に整った、信頼できるFX業者です。
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
          <p className="text-xs text-gray-500 leading-relaxed">
            <strong>※リスクに関する注意事項：</strong>FX取引にはリスクが伴います。取引を行う際は、ご自身の判断と責任において行ってください。レバレッジ取引では、投資元本を超える損失が発生する可能性があります。取引を始める前に、DMM FXの公式サイトで契約締結前交付書面等をよくお読みいただき、リスクについて十分にご理解ください。
          </p>
        </div>

        <div className="text-center mt-10">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-amber-400 to-orange-500 text-gray-900 px-4 py-2 rounded-full text-sm font-bold mb-4 animate-pulse">
            <i className="ri-gift-line"></i>
            <span>👉 今だけ最大50万円キャッシュバック</span>
          </div>
          <div className="block">
            <a
              href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82"
              rel="nofollow"
              className="inline-block bg-gradient-to-b from-orange-500 to-orange-600 text-white px-8 py-5 rounded-xl text-xl font-bold hover:scale-105 hover:-translate-y-1 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-[0_6px_18px_rgba(0,0,0,0.25)]"
            >
              👉 今だけ最大50万円キャッシュバック<br />
              無料でDMM FX口座を開設する
            </a>
            <img
              border={0}
              width={1}
              height={1}
              src="https://www13.a8.net/0.gif?a8mat=4AX8OA+BW2OQA+1WP2+6JC82"
              alt=""
              style={{ display: 'none' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
